import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from "@mui/icons-material/Article"; // DOC icon
import DescriptionIcon from "@mui/icons-material/Description"; // For CSV
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
export const getFileIcon=(fileName)=>
    {
      // const fileName = fileType.split('.').pop().toLowerCase();
        
      if (fileName.includes("pdf")) {
        return <PictureAsPdfIcon sx={{ color: "red", fontSize: "20px" , marginRight: "5px"}} />;
      }
      if (fileName.includes("docx") || fileName.includes("doc")) {
        return <ArticleIcon sx={{ color: "blue", fontSize: "20px" , marginRight: "5px" }} />;
      }
      if (
        fileName.includes("xlsx") ||
        fileName.includes("xls") ||
        fileName.includes("sheet")
      ) {
        return <DescriptionIcon sx={{ color: "green", fontSize: "20px" , marginRight: "5px"}} />;
      }
      return <TextSnippetOutlinedIcon sx={{ fontSize: "20px",  marginRight: "5px"}} />;
    };


    export const getFileName = (fileUrl) => {

        // Decode the URL
        const decodedUrl = decodeURIComponent(fileUrl);
      
        // Extract the filename from the URL
        const fullFileName = decodedUrl.split("/").pop(); // Get the last part of the URL
      

        // Split the filename by underscores
        const parts = fullFileName.split("_");
      
        // Remove the last two parts (date and time)
        const fileNameParts = parts.slice(1, -2);
      
        // Join the remaining parts to form the original filename
        const originalFileName = fileNameParts.join("_");
      
        // Return the cleaned filename

        return originalFileName;
      };
     